import { createApiRef } from '@backstage/core-plugin-api';
// import { IEpDevPConsumerProductsApiClient } from '@solace-labs/backstage-plugin-ep-devp-consumer-products-common';
import { IEpDevPConsumerProductsApiClient } from '../../../ep-devp-consumer-products-common';

import { EpDevPPluginIds } from '@solace-labs/backstage-plugin-ep-devp-common';


export const epDevPConsumerProductsApiRef = createApiRef<IEpDevPConsumerProductsApiClient>({
  id: `${EpDevPPluginIds.EpDevPConsumerProductsPluginId}.api-ref`
});
